// import adiValidateAdiNumber from "@NA/Handlers/ADIValidateAdiNumber";
// import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
// import ApplicationState from "@insite/client-framework/Store/ApplicationState";
// import { getAllBrandsDataView } from "@insite/client-framework/Store/Data/Brands/BrandsSelectors";
// import loadBrands from "@insite/client-framework/Store/Data/Brands/Handlers/LoadBrands";
// import { getCategoriesDataView } from "@insite/client-framework/Store/Data/Categories/CategoriesSelectors";
// import loadAllBrands from "@insite/client-framework/Store/Pages/Brands/Handlers/LoadAllBrands";
// import translate from "@insite/client-framework/Translate";
// import Button from "@insite/mobius/Button";
// import GridContainer, { GridOffset } from "@insite/mobius/GridContainer";
// import GridItem, { GridItemProps, GridItemStyle } from "@insite/mobius/GridItem";
// import Modal, { ModalPresentationProps } from "@insite/mobius/Modal";
// import Radio from "@insite/mobius/Radio";
// import RadioGroup, { RadioGroupProps, RadioGroupStyle } from "@insite/mobius/RadioGroup";
// import TextField, { TextFieldPresentationProps } from "@insite/mobius/TextField";
// import cloneDeep from "lodash/cloneDeep";
// import React, { FC, useEffect, useState } from "react";
// import { ResolveThunks, connect } from "react-redux";
// import { css } from "styled-components";
// import { breakpointMediaQueries, getProp } from "@insite/mobius/utilities";
// import InjectableCss from "@insite/mobius/utilities/InjectableCss";
// import Typography, { TypographyPresentationProps, TypographyProps } from "@insite/mobius/Typography";
// import { FormInputWrapper } from "@insite/mobius/FormField";
// import ADIColors from "@NA/Utils/ADIColors";
// import { getBrandsDataView } from "@insite/client-framework/Store/Data/Brands/BrandsSelectors";
// import CustomApplicationState from "@NA/Store/Data/CustomApplicationState/CustomApplicationState";
// import clearAllProductFilters from "@insite/client-framework/Store/Pages/ProductList/Handlers/ClearAllProductFilters";
// import { Category } from "@insite/client-framework/Services/CategoryService";
// import { VisualFilter, categoryId } from "@NA/Services/GetVisualCarousal";

// interface OwnProps {
//     closeModal: () => void;
//     modalOpen: boolean;
//     dataForGridItemIndex: any;
//     setDataForGridItemIndex: any;
//     dataForGridItems: VisualFilter[];
//     defaultItem: any;
//     category?: Readonly<Category>;
//     setDataForGridItemsHandler: (a: any) => void;
//     setItemsDisabledHandler: (a: number) => void;
// }

// const mapStateToProps = (state: ApplicationState) => {
//     const allBrandsDataView = getAllBrandsDataView(state);
//     const catalogSettings = state.context.settings.settingsCollection.catalogSettingSettings as any;
//     return {
//         allBrandsDataView,
//         brandAlphabetState: state.pages.brands.brandAlphabetState,
//         imageCDNPath: catalogSettings.cdnPathVisNav,
//         categoriesDataView: getCategoriesDataView(state),
//     };
// };

// const mapDispatchToProps = {
//     adiValidateAdiNumber,
//     loadBrands,
//     loadAllBrands,
//     clearAllProductFilters,
// };

// type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

// export interface ADIProductListVisualFilterModalStyles {
//     modalInputGrid?: GridItemProps;
//     formTextField?: TextFieldPresentationProps;
//     radioGridItem?: GridItemProps;
//     radioListGroup?: RadioGroupProps;
//     errorText?: InjectableCss;
//     textFieldsErrorStyle: TextFieldPresentationProps;
//     editModal?: ModalPresentationProps;
// }

// export const adiProductListVisualFilterModalStyles: ADIProductListVisualFilterModalStyles = {
//     modalInputGrid: {
//         width: 12,
//         css: css`
//             & > div:first-child {
//                 width: 100%;
//             }
//             padding: 0 15px;
//             .modalSave {
//                 margin-top: 19px;
//                 margin-right: 25px;
//                 border: 1px solid #006ae3;
//                 background-color: #006ae3 !important;
//                 min-width: 90px;
//                 &:disabled {
//                     opacity: 0.4 !important;
//                     border: 1px solid #006ae3;
//                     background-color: #006ae3 !important;
//                 }
//             }
//             .modalCancel {
//                 margin-top: 19px;
//             }
//         `,
//     },
//     editModal: {
//         cssOverrides: {
//             modalBody: css`                   
//                 border-radius: 7px!important;
//                 box-shadow:0 1px 9px 0 rgba(0,0,0,.14)!important;
//                 border: none!important;
//                 background-color: #fff;!important;
                
//                 max-height: 100% !important;                                
//             `,
//             modalContent: css`
//                 padding: 0px 48px 43px 48px !important;
//                 ${GridOffset} {
//                     width: 100% !important;
//                     margin: 0px !important;
//                     ${GridItemStyle} {
//                         padding: 0px !important;
//                         margin-bottom: 17px;
//                         &:last-child {
//                             margin-bottom: 0px;
//                         }
//                     }
//                 }
//             `,
//             modalTitle: css`
//                 padding: 32px 48px 0px 48px !important;
//                 font-size: 16px;
//                 font-weight: 400;
//                 line-height: 24px;
//                 border: none !important;
//                 > h4 {
//                     font-size: 16px;
//                     font-weight: 400;
//                     line-height: 24px;
//                     color: #060001;
//                 }
//                 > button {
//                     position: absolute;
//                     right: 5px;
//                     top: 5px;
//                     > span {
//                         color: #006ae3;
//                         width: 35px;
//                         height: 35px;
//                         > svg {
//                             color: #006ae3;
//                             width: 35px;
//                             height: 35px;
//                             stroke-width: 1px;
//                         }
//                     }
//                 }
//             `,
//         },
//     },
//     formTextField: {
//         css: css`
//             max-width: 260px;
//             border-radius: 7px;
//             border: 1px solid #bbb;
//         `,
//     },
//     radioGridItem: {
//         css: css`
//             display: flex;
//             flex-direction: column;
//             > ${RadioGroupStyle} {
//                 display: flex;
//             }
//         `,
//     },
//     radioListGroup: {
//         css: css`
//             & > div {
//                 margin-right: 10px !important;
//                 input {
//                     position: absolute;
//                 }
//                 label {
//                     font-weight: bold;
//                     margin: 0px;
//                     white-space: nowrap;
//                 }
//             }
//         `,
//     },
//     errorText: {
//         css: css`
//             color: ${ADIColors.danger};
//             font-size: 14px;
//             font-weight: 800;
//             max-width: 326px;
//         `,
//     },
//     textFieldsErrorStyle: {
//         css: css`
//             border: 1px solid ${ADIColors.danger} !important;
//             max-width: 260px;
//             > ${FormInputWrapper} > input {
//                 height: 45px;
//                 width: 288px;
//             }
//         `,
//     },
// };

// const styles = adiProductListVisualFilterModalStyles;

// const ADIProductListVisualFilterModal: FC<Props> = ({
//     closeModal,
//     modalOpen,
//     adiValidateAdiNumber,
//     allBrandsDataView,
//     brandAlphabetState,
//     imageCDNPath,
//     dataForGridItemIndex,
//     dataForGridItems,
//     categoriesDataView,
//     loadBrands,
//     loadAllBrands,
//     defaultItem,
//     setDataForGridItemIndex,
//     clearAllProductFilters,
//     category,
//     setDataForGridItemsHandler,
//     setItemsDisabledHandler,
// }) => {
//     const titleRequiredFieldMessage = "Please provide a Title to be displayed for the image.";
//     const gaPromoTagRequiredFieldMessage = "Please provide a tag name to be applied to the filter.";
//     const imageNumberRequiredFieldMessage = "Please provide an ADI Number for the Image to be displayed.";

//     const [titleError, setTitleError] = useState("");
//     const [gaPromoTagError, setGaPromoTagError] = useState("");
//     const [imageNumberError, setImageNumberError] = useState("");
//     const [imageNumber, setImageNumber] = useState("");
//     const [filterTitle, setFilterTitle] = useState("Filter Title");
//     const [gaPromoTag, setGaPromoTag] = useState("");
//     const [isSubmitting, setIsSubmitting] = useState(false);
//     const [isSubmitted, setIsSubmitted] = useState(false);
//     const [selectedRadio, setSelectedRadio] = useState("imgNum");
//     const [removeAllFields, setRemoveAllFields] = useState(true);
//     const [isImageLoaded, setIsImageLoaded] = useState(false);
//     const [isImageError, setIsImageError] = useState(false);

//     const filterCat: categoryId = {
//         categoryId: category ? category.id : "",
//         shortDescription: category ? category.shortDescription : "",
//     };

//     useEffect(() => {
//         const data = cloneDeep(dataForGridItems);
//         const visualNavTypeMap: any = {
//             1: "imgNum",
//             2: "pimId",
//             3: "imgName",
//         };
//         if (data && data[dataForGridItemIndex]) {
//             setFilterTitle(data[dataForGridItemIndex].filterTitle);
//             setGaPromoTag(data[dataForGridItemIndex].dataGaPromo);
//             setImageNumber(data[dataForGridItemIndex].productNumber);
//             setSelectedRadio(visualNavTypeMap[data[dataForGridItemIndex].visualNavType]);
//         }
//     }, [dataForGridItemIndex]);

//     useEffect(() => {
//         if (!allBrandsDataView?.value) {
//             loadAllBrands({
//                 sort: "name asc",
//                 select: "",
//                 expand: "properties",
//             });
//         }
//     }, []);

//     const validateImageName = (imagename: string) => {
//         const img = new Image();
//         const handleImageLoad = () => {
//             setIsImageLoaded(true);
//         };
//         const handleImageError = () => {
//             setIsImageError(false);
//         };
//         img.onload = handleImageLoad;
//         img.onerror = handleImageError;

//         img.src = imagename;
//     };

//     const validateSubmitEnabled = () => {
//         return !(titleError || gaPromoTagError || imageNumberError);
//     };

//     const isSubmitEnabled = validateSubmitEnabled();

//     const SaveVisualNavigationPopupData = (
//         title: string,
//         index: number,
//         productNumber: string,
//         dataGaPromo: string,
//         visNavType: any,
//     ) => {
//         const data = cloneDeep(dataForGridItems);
//         let imagepath: any = "";
//         let adinumber: any = "";

//         let isSubmitEnabled = true; // Initialize isSubmitEnabled as true
//         if (!validateImage(productNumber, visNavType)) return;

//         if (visNavType === "imgNum") {
//             adiValidateAdiNumber({
//                 adiNumber: productNumber,
//                 onSuccess: (result: any) => {
//                     if (result.adiNumber === "Invalid") {
//                         setImageNumberError("Please provide a valid ADI Number for the Image to be displayed.");
//                     } else {
//                         if (data && data[index]) {
//                             setFiltersToSave(
//                                 title,
//                                 productNumber,
//                                 index,
//                                 dataGaPromo,
//                                 visNavType,
//                                 result.adiNumber,
//                                 result.imageURL,
//                             );
//                             setRemoveAllFields(false);
//                             closeModal();
//                             clearAllProductFilters();
//                         }
//                     }
//                 },
//             });
//         } else if (visNavType === "pimId") {
//             const pidBrand =
//                 allBrandsDataView?.value?.filter((brand: any) => brand.properties.branD_ID === productNumber) || [];
//             if (pidBrand.length > 0) {
//                 const adinumber = productNumber;
//                 const imagepath = pidBrand[0]?.logoSmallImagePath;
//                 setFiltersToSave(title, productNumber, index, dataGaPromo, visNavType, adinumber, imagepath);
//                 setIsSubmitted(true);
//                 closeModal();
//                 clearAllProductFilters();
//             } else {
//                 setImageNumberError("Please provide valid PIM Brand ID for the vendor logo to be displayed.");
//             }
//         } else if (visNavType === "imgName") {
//             const imagename = `${imageCDNPath}${productNumber}`;
//             if (!isImageLoaded)
//                 setImageNumberError(
//                     "Please provide a valid file name and extension such as(.jpg) for the image to be displayed.",
//                 );
//             else {
//                 const adinumber = productNumber;
//                 const imagepath = imagename;
//                 setFiltersToSave(title, productNumber, index, dataGaPromo, visNavType, adinumber, imagepath);
//                 setIsSubmitted(true);
//                 closeModal();
//                 clearAllProductFilters();
//             }
//         }
//     };

//     const setFiltersToSave = (
//         title: string,
//         productNumber: string,
//         index: number,
//         dataGaPromo: string,
//         visNavType: any,
//         adiNumber: string,
//         imageUrl: string,
//     ) => {
//         const urlParm = new URLSearchParams(window.location.search);
//         let attributeValues = urlParm.get("attributes");
//         let listSortType = urlParm.get("sort");
//         visNavType =
//             visNavType === "imgNum" ? 1 : visNavType === "pimId" ? 2 : visNavType === "imgName" ? 3 : visNavType;
//         if (adiNumber != "Invalid") {
//             const newdata = dataForGridItems.map((data: VisualFilter, ind: number) => {
//                 if (data && index == ind) {
//                     return {
//                         ...data,
//                         visualFilterID: "",
//                         categoryID: JSON.stringify(filterCat),
//                         filterTitle: title,
//                         productNumber: productNumber,
//                         productImage: imageUrl,
//                         attributeFilters: attributeValues ?? "",
//                         pageURL: window.location.pathname,
//                         sort: listSortType ?? "",
//                         expand: "['pricing'; 'attributes'; 'facets']",
//                         dataGaPromo: dataGaPromo,
//                         visualNavType: visNavType,
//                     };
//                 } else {
//                     return data;
//                 }
//             });
//             setDataForGridItemsHandler(newdata);
//             setItemsDisabledHandler(index);
//             clearAllProductFilters(); // clear left filter
//         }
//     };

//     const validateTitle = (name: string) => {
//         const errorMessage = !name ? titleRequiredFieldMessage : "";
//         setTitleError(errorMessage);
//         return !errorMessage;
//     };

//     const validateGaPromoTag = (tag: string) => {
//         const errorMessage = !tag ? gaPromoTagRequiredFieldMessage : "";
//         setGaPromoTagError(errorMessage);
//         return !errorMessage;
//     };

//     const handleRadioChange = (value: string) => {
//         setSelectedRadio(value);
//         validateImage(imageNumber, value);
//         if (value === "pimId" && !allBrandsDataView?.value) {
//             loadAllBrands({
//                 sort: "name asc",
//                 select: "",
//                 expand: "properties",
//             });
//         }
//     };

//     const validateImage = (value: string, radioSelection: string) => {
//         const acceptedFiles = [
//             "Sale.jpg",
//             "Clearance.jpg",
//             "InStock.jpg",
//             "Accessories.jpg",
//             "New.jpg",
//             "Deals.jpg",
//             "NDAA.jpg",
//             "OvrC-logo.jpg",
//         ];
//         let errorMessage = "";
//         if (radioSelection === "imgNum") {
//             errorMessage = !value ? "Please provide an ADI Number for the Image to be displayed." : "";
//         } else if (radioSelection === "pimId") {
//             errorMessage = !value ? "Please provide PIM Brand ID for the vendor logo to be displayed." : "";
//         } else if (radioSelection === "imgName" && acceptedFiles.includes(value)) {
//             errorMessage = !acceptedFiles.includes(value)
//                 ? "Please provide a file name and extension such as (.jpg) for the image to be displayed."
//                 : "";
//             const imagename = `${imageCDNPath}${value}`;
//             validateImageName(imagename);
//         }
//         setImageNumberError(errorMessage);
//         return !errorMessage; // Return true if validation passes, false otherwise
//     };

//     const titleChangeHandler = (value: string) => {
//         validateTitle(value);
//         setFilterTitle(value);
//     };

//     const gaPromoTagChangeHandler = (value: string) => {
//         validateGaPromoTag(value);
//         setGaPromoTag(value);
//     };

//     const imageChangeHandler = (value: string) => {
//         setImageNumber(value);
//         validateImage(value, selectedRadio);
//     };

//     const clearFormFields = () => {
//         setIsSubmitted(false);
//         setIsSubmitting(false);
//         setSelectedRadio("");
//         setDataForGridItemIndex("");
//     };

//     const closeModalAndClearForm = () => {
//         if (removeAllFields) {
//             clearFormFields();
//         }
//         closeModal();
//     };

//     return (
//         <Modal
//             headline={`Edit Filter Slide (${dataForGridItemIndex + 1})`}
//             isOpen={modalOpen}
//             handleClose={closeModalAndClearForm}
//             sizeVariant={"small"}
//             {...styles.editModal}
//         >
//             <StyledWrapper id="popup-visual-navigation-edit">
//                 <GridContainer>
//                     <GridItem {...styles.modalInputGrid}>
//                         <StyledWrapper>
//                             <TextField
//                                 type="text"
//                                 label={"Filter Title"}
//                                 value={filterTitle}
//                                 onChange={e => titleChangeHandler(e.target.value)}
//                                 onBlur={e => validateTitle(e.target.value)}
//                                 required
//                                 error={!!titleError}
//                                 {...(titleError ? styles.textFieldsErrorStyle : styles.formTextField)}
//                             />
//                             {titleError && <Typography {...styles.errorText}>{titleRequiredFieldMessage}</Typography>}
//                         </StyledWrapper>
//                     </GridItem>
//                     <GridItem width={12} {...styles.radioGridItem}>
//                         <RadioGroup
//                             horizontal={true}
//                             value={selectedRadio}
//                             onChange={(e: any) => handleRadioChange(e.target.value)}
//                             {...styles.radioListGroup}
//                         >
//                             <Radio value="imgNum">{"ADI Image Number"}</Radio>
//                             <Radio value="pimId">{"PIM Brand ID"}</Radio>
//                             <Radio value="imgName">{"Image Name"}</Radio>
//                         </RadioGroup>
//                         <TextField
//                             type="text"
//                             placeholder={`Enter ${
//                                 selectedRadio === "imgNum"
//                                     ? "ADI Image Number"
//                                     : selectedRadio === "pimId"
//                                     ? "PIM Brand ID"
//                                     : "Image Name"
//                             }`}
//                             value={imageNumber}
//                             onChange={e => imageChangeHandler(e.target.value)}
//                             onBlur={e => validateImage(e.target.value, selectedRadio)}
//                             required
//                             error={!!imageNumberError}
//                             {...(imageNumberError ? styles.textFieldsErrorStyle : styles.formTextField)}
//                         />
//                         {imageNumberError && <Typography {...styles.errorText}>{imageNumberError}</Typography>}
//                     </GridItem>
//                     <GridItem {...styles.modalInputGrid}>
//                         <StyledWrapper>
//                             <TextField
//                                 type="text"
//                                 label={"GA Promo Tag"}
//                                 value={gaPromoTag}
//                                 onChange={e => gaPromoTagChangeHandler(e.target.value)}
//                                 onBlur={e => validateGaPromoTag(e.target.value)}
//                                 required
//                                 error={!!gaPromoTagError}
//                                 {...(gaPromoTagError ? styles.textFieldsErrorStyle : styles.formTextField)}
//                             />
//                             {gaPromoTagError && (
//                                 <Typography {...styles.errorText}>{gaPromoTagRequiredFieldMessage}</Typography>
//                             )}
//                         </StyledWrapper>
//                     </GridItem>
//                     <GridItem {...styles.modalInputGrid}>
//                         <Button
//                             onClick={() =>
//                                 SaveVisualNavigationPopupData(
//                                     filterTitle,
//                                     dataForGridItemIndex,
//                                     imageNumber,
//                                     gaPromoTag,
//                                     selectedRadio,
//                                 )
//                             }
//                             variant="primary"
//                             className="modalSave"
//                             disabled={isSubmitting || !isSubmitEnabled}
//                         >
//                             {translate("Save")}
//                         </Button>
//                         <Button onClick={closeModalAndClearForm} variant="secondary" className="modalCancel">
//                             {translate("Cancel")}
//                         </Button>
//                     </GridItem>
//                 </GridContainer>
//             </StyledWrapper>
//         </Modal>
//     );
// };

// export default connect(mapStateToProps, mapDispatchToProps)(ADIProductListVisualFilterModal);

import adiValidateAdiNumber from "@NA/Handlers/ADIValidateAdiNumber";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getAllBrandsDataView } from "@insite/client-framework/Store/Data/Brands/BrandsSelectors";
import loadBrands from "@insite/client-framework/Store/Data/Brands/Handlers/LoadBrands";
import { getCategoriesDataView } from "@insite/client-framework/Store/Data/Categories/CategoriesSelectors";
import loadAllBrands from "@insite/client-framework/Store/Pages/Brands/Handlers/LoadAllBrands";
import translate from "@insite/client-framework/Translate";
import Button from "@insite/mobius/Button";
import GridContainer , { GridOffset } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps , GridItemStyle } from "@insite/mobius/GridItem";
import Modal , { ModalPresentationProps } from "@insite/mobius/Modal";
import Radio from "@insite/mobius/Radio";
import RadioGroup, { RadioGroupProps , RadioGroupStyle} from "@insite/mobius/RadioGroup";
import TextField, { TextFieldPresentationProps } from "@insite/mobius/TextField";
import cloneDeep from "lodash/cloneDeep";
import React, { FC, useEffect, useState } from "react";
import { ResolveThunks, connect } from "react-redux";
import { css } from "styled-components";
import { breakpointMediaQueries, getProp } from "@insite/mobius/utilities";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import Typography, { TypographyPresentationProps, TypographyProps } from "@insite/mobius/Typography";
import { FormInputWrapper } from "@insite/mobius/FormField";
import ADIColors from "@NA/Utils/ADIColors";
import { getBrandsDataView } from "@insite/client-framework/Store/Data/Brands/BrandsSelectors";
import CustomApplicationState from "@NA/Store/Data/CustomApplicationState/CustomApplicationState";
import clearAllProductFilters from "@insite/client-framework/Store/Pages/ProductList/Handlers/ClearAllProductFilters";
import { Category } from "@insite/client-framework/Services/CategoryService";
import { VisualFilter, categoryId } from "@NA/Services/GetVisualCarousal";

interface OwnProps {
    closeModal: () => void;
    modalOpen: boolean;
    dataForGridItemIndex: any;
    setDataForGridItemIndex: any;
    dataForGridItems: VisualFilter[];
    defaultItem: any;
    category?: Readonly<Category>;
    setDataForGridItemsHandler: (a: any) => void;
    setItemsDisabledHandler:(a: number)=> void;
    imageAcceptedName:string;
}

const mapStateToProps = (state: ApplicationState) => {
    const allBrandsDataView = getAllBrandsDataView(state);
    const catalogSettings = state.context.settings.settingsCollection.catalogSettingSettings as any;
    return {
        allBrandsDataView,
        brandAlphabetState: state.pages.brands.brandAlphabetState,
        imageCDNPath: catalogSettings.cdnPathVisNav,
        categoriesDataView: getCategoriesDataView(state),
    };
};

const mapDispatchToProps = {
    adiValidateAdiNumber,
    loadBrands,
    loadAllBrands,
    clearAllProductFilters
};

type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

export interface ADIProductListVisualFilterModalStyles {
    modalInputGrid?: GridItemProps;
    formTextField?: TextFieldPresentationProps;
    sequenceTextField?:TextFieldPresentationProps;
    radioGridItem?: GridItemProps;
    radioListGroup?: RadioGroupProps;
    errorText?: InjectableCss;
    textFieldsErrorStyle: TextFieldPresentationProps;
    editModal?:ModalPresentationProps;
}

export const adiProductListVisualFilterModalStyles: ADIProductListVisualFilterModalStyles = {
    modalInputGrid: {
        width: 12,
        css: css`
            & > div:first-child {
                width: 100%;
            }
            padding: 0 15px;
            .modalSave {
                 margin-top:19px;
                margin-right: 25px;
                border:1px solid #006AE3;
                background-color: #006ae3!important;
                min-width:90px;
                &:disabled{
                    opacity:.4!important;
                    border:1px solid #006AE3;
                    background-color: #006ae3!important;
                }
            }
            .modalCancel {
                margin-top:19px;
            }
        `,
    },
    editModal:{
        cssOverrides: {          
            modalBody: css`                   
                border-radius: 7px!important;
                box-shadow:0 1px 9px 0 rgba(0,0,0,.14)!important;
                border: none!important;
                background-color: #fff;!important;
                
                max-height: 100% !important;                                
            `,
            modalContent: css`
                padding : 0px 48px 43px 48px!important;
                ${GridOffset}{
                    width:100%!important;
                    margin:0px!important;
                    ${GridItemStyle}{
                        padding:0px!important;  
                        margin-bottom:17px;   
                        &:last-child{
                            margin-bottom:0px;
                        }             
                    }               
                }
            `,
            modalTitle: css`
                padding :32px 48px 0px 48px!important;
                font-size: 16px;
                font-weight:400;
                line-height:24px;
                border:none !important;
            > h4 {
                font-size: 16px;
                font-weight:400;
                line-height:24px;              
                color: #060001;                
            }
            > button {
                position: absolute;
                right: 5px;
                top: 5px;
                > span {
                    color: #006AE3;
                    width: 35px;
                    height: 35px;
                    > svg {
                        color: #006AE3;
                        width: 35px;
                        height: 35px;
                        stroke-width: 1px;
                    }             
                }                 
            }           
            `,
        }
    },sequenceTextField:{
        css: css`
            max-width: 100px;
            border-radius: 7px;
            border: 1px solid #bbb;
    `, 
    },
    formTextField:{
        css: css`
            max-width: 260px;
            border-radius: 7px;
            border: 1px solid #bbb;
    `, 
    },
    radioGridItem: {
        css: css`
            display: flex;
            flex-direction: column;
            > ${RadioGroupStyle} {
                display:flex;
            }
        `,
    },
    radioListGroup: {
        css: css`
            & > div {
                margin-right: 10px !important;
                input{
                    position:absolute;
                }
                label {
                    font-weight: bold;
                    margin: 0px;
                    white-space:nowrap;
                }
            }
        `,
    },
    errorText: {
        css: css`
            color: ${ADIColors.danger};
            font-size: 14px;
            font-weight: 800;
            max-width: 326px;
        `,
    },
    textFieldsErrorStyle: {
        css: css`
            border: 1px solid ${ADIColors.danger} !important;
             max-width:260px;
            > ${FormInputWrapper} > input {
                height: 45px;
                width: 288px;
            }
        `,
    },
};

const styles = adiProductListVisualFilterModalStyles;

const ADIProductListVisualFilterModal: FC<Props> = ({
    closeModal,
    modalOpen,
    adiValidateAdiNumber,
    allBrandsDataView,
    brandAlphabetState,
    imageCDNPath,
    dataForGridItemIndex,
    dataForGridItems,
    categoriesDataView,
    loadBrands,
    loadAllBrands,
    defaultItem,
    setDataForGridItemIndex,
    clearAllProductFilters,
    category,
    setDataForGridItemsHandler,
    setItemsDisabledHandler,
    imageAcceptedName,
}) => {
    const titleRequiredFieldMessage = "Please provide a Title to be displayed for the image.";
    const sequenceRequiredFieldMessage = "Please provide a Slide No.";
    const gaPromoTagRequiredFieldMessage = "Please provide a tag name to be applied to the filter.";
    const imageNumberRequiredFieldMessage = "Please provide an ADI Number for the Image to be displayed.";

    const [titleError, setTitleError] = useState("");
    const [gaPromoTagError, setGaPromoTagError] = useState("");
    const [imageNumberError, setImageNumberError] = useState("");
    const [imageNumber, setImageNumber] = useState("");
    const [filterTitle, setFilterTitle] = useState("Filter Title");
    const [gaPromoTag, setGaPromoTag] = useState("");
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [isSubmitted, setIsSubmitted] = useState(false);
    const [selectedRadio, setSelectedRadio] = useState("imgNum");
    const [removeAllFields, setRemoveAllFields] = useState(true);
    const [isImageLoaded, setIsImageLoaded] = useState(false);
    const [isImageError, setIsImageError] = useState(false);
    const [sequenceNumber, setSequenceNumber]= useState<number>(0);
    const [sequenceError, setSequenceError] = useState("");
    const [outsideLink, setOutsideLink] = useState("");

    const filterCat : categoryId = {
        categoryId: (category ? category.id : ""),
        shortDescription: category ? category.shortDescription : ""
    };

    useEffect(() => {
        const data = cloneDeep(dataForGridItems);
        const visualNavTypeMap: any = {
            1: "imgNum",
            2: "pimId",
            3: "imgName",
        };
        if (data && data[dataForGridItemIndex]) {
            setSequenceNumber(data[dataForGridItemIndex].slideNumber);
            setOutsideLink(data[dataForGridItemIndex].adiLink)
            setFilterTitle(data[dataForGridItemIndex].filterTitle);
            setGaPromoTag(data[dataForGridItemIndex].dataGaPromo);
            setImageNumber(data[dataForGridItemIndex].productNumber);
            setSelectedRadio(visualNavTypeMap[data[dataForGridItemIndex].visualNavType]);
        }
    }, [dataForGridItemIndex]);

    useEffect(()=> {
        if(!allBrandsDataView?.value){
            loadAllBrands({
                sort: "name asc",
                select: "",
                expand: "properties",
            });
        }
    }, []);

    const validateImageName = (imagename: string) => {
        const img = new Image();
        const handleImageLoad = () => {
            setIsImageLoaded(true);
        };
        const handleImageError = () => {
            setIsImageError(false);
        };
        img.onload = handleImageLoad;
        img.onerror = handleImageError;

        img.src = imagename;
    };

    const validateSubmitEnabled = () => {
        return !(titleError || gaPromoTagError || imageNumberError);
    };

    const isSubmitEnabled = validateSubmitEnabled();

    const SaveVisualNavigationPopupData = (
        title: string,
        index: number,
        productNumber: string,
        dataGaPromo: string,
        visNavType: any,
        sequenceNumber:number,
        outsideLink:string
    ) => {
        const data = cloneDeep(dataForGridItems);
        let imagepath: any = "";
        let adinumber: any = "";

        let isSubmitEnabled = true; // Initialize isSubmitEnabled as true
        if (!validateImage(productNumber, visNavType)) return;

        if (visNavType === "imgNum") {
            adiValidateAdiNumber({
                adiNumber: productNumber,
                onSuccess: (result: any) => {
                    if (result.adiNumber === "Invalid") {
                        setImageNumberError("Please provide a valid ADI Number for the Image to be displayed.");
                    } else {
                        if (data && data[index]) {
                            setFiltersToSave(
                                title,
                                productNumber,
                                index,
                                dataGaPromo,
                                visNavType,
                                result.adiNumber,
                                result.imageURL,
                                sequenceNumber,
                                outsideLink
                            );
                            setRemoveAllFields(false);
                            closeModal();
                            clearAllProductFilters();
                        }
                    }
                },
            });
        } else if (visNavType === "pimId") {
            const pidBrand = allBrandsDataView?.value?.filter(
                (brand: any) => brand.properties.branD_ID === productNumber,
            ) || [];
            if (pidBrand.length > 0) {
                const adinumber = productNumber;
                const imagepath = pidBrand[0]?.logoSmallImagePath;
                setFiltersToSave(title, productNumber, index, dataGaPromo, visNavType, adinumber, imagepath,sequenceNumber,outsideLink);
                setIsSubmitted(true);
                closeModal();
                clearAllProductFilters();
            } else {
                setImageNumberError("Please provide valid PIM Brand ID for the vendor logo to be displayed.");
            }
        } else if (visNavType === "imgName") {
            const imagename = `${imageCDNPath}${productNumber}`;
            if (!isImageLoaded)
                setImageNumberError(
                    "Please provide a valid file name and extension such as(.jpg) for the image to be displayed.",
                );
            else {
                const adinumber = productNumber;
                const imagepath = imagename;
                setFiltersToSave(title, productNumber, index, dataGaPromo, visNavType, adinumber, imagepath,sequenceNumber,outsideLink);
                setIsSubmitted(true);
                closeModal();
                clearAllProductFilters();
            }
        }
    };

    const setFiltersToSave = (
        title: string,
        productNumber: string,
        index: number,
        dataGaPromo: string,
        visNavType: any,
        adiNumber: string,
        imageUrl: string,
        sequenceNumber:number,
        outsideLink:string
    ) => {
        const urlParm = new URLSearchParams(window.location.search);
        let attributeValues = urlParm.get('attributes');       
        let listSortType = urlParm.get('sort');
        visNavType =
            visNavType === "imgNum" ? 1 : visNavType === "pimId" ? 2 : visNavType === "imgName" ? 3 : visNavType;
        if (adiNumber != "Invalid") {
            const newdata = dataForGridItems.map((data: VisualFilter, ind: number)=>
            {
                if (data && index == ind) {
                    return { ...data,
                    visualFilterID : "",
                    categoryID: JSON.stringify(filterCat),
                    filterTitle: title,
                    productNumber: productNumber,
                    productImage: imageUrl,
                    attributeFilters: attributeValues??"",
                    pageURL: window.location.pathname,
                    sort : listSortType??"",
                    expand : "['pricing'; 'attributes'; 'facets']",
                    dataGaPromo : dataGaPromo,
                    visualNavType : visNavType,
                    slideNumber : sequenceNumber,
                    adiLink:outsideLink 
                    }
                } else {
                    return data;
                }
            });
            setDataForGridItemsHandler(newdata);
            setItemsDisabledHandler(index);
            clearAllProductFilters(); // clear left filter
        } 
    };

    const validateTitle = (name: string) => {
        const errorMessage = !name ? titleRequiredFieldMessage : "";
        setTitleError(errorMessage);
        return !errorMessage;
    };
    const validateSequence = (name: Number) => {
        const errorMessage = !name ? sequenceRequiredFieldMessage : "";
        setSequenceError(errorMessage);
        return !errorMessage;
    };

    const validateGaPromoTag = (tag: string) => {
        const errorMessage = !tag ? gaPromoTagRequiredFieldMessage : "";
        setGaPromoTagError(errorMessage);
        return !errorMessage;
    };

    const handleRadioChange = (value: string) => {
        setSelectedRadio(value);
        validateImage(imageNumber, value);
        if (value === "pimId" && !allBrandsDataView?.value) {
            loadAllBrands({
                sort: "name asc",
                select: "",
                expand: "properties",
            });
        }
    };

    const validateImage = (value: string, radioSelection: string) => {
       const acceptedFiles = imageAcceptedName.split(',')
       console.log("validateImage ---", value ,radioSelection)
        let errorMessage = "";
        if (radioSelection === "imgNum") {
            errorMessage = !value ? "Please provide an ADI Number for the Image to be displayed." : "";
        } else if (radioSelection === "pimId") {
            errorMessage = !value ? "Please provide PIM Brand ID for the vendor logo to be displayed." : "";
        } else if (radioSelection === "imgName"&& acceptedFiles.includes(value)) {
            errorMessage = !acceptedFiles.includes(value)
                ? "Please provide a file name and extension such as (.jpg) for the image to be displayed."
                : "";
            const imagename = `${imageCDNPath}${value}`;
            validateImageName(imagename);
        }
        setImageNumberError(errorMessage);
        return !errorMessage; // Return true if validation passes, false otherwise
    };

    const titleChangeHandler = (value: string) => {
        validateTitle(value);
        setFilterTitle(value);
    };

    const sequenceChangeHandler = (value: number) => {
        validateSequence(value)
        setSequenceNumber(value);
    };

    const gaPromoTagChangeHandler = (value: string) => {
        validateGaPromoTag(value);
        setGaPromoTag(value);
    };

    const ousideLinkChangeHandler = (value: string) => {
        setOutsideLink(value);
    };

    const imageChangeHandler = (value: string) => {
        setImageNumber(value);
        validateImage(value, selectedRadio);
    };

    const clearFormFields = () => {
        setIsSubmitted(false);
        setIsSubmitting(false);
        setSelectedRadio("");
        setDataForGridItemIndex("");
    };

    const closeModalAndClearForm = () => {
        if (removeAllFields) {
            clearFormFields();
        }
        closeModal();
    };

    return (
        <Modal
            headline={`Edit Filter Slide (${dataForGridItemIndex + 1})`}
            isOpen={modalOpen}
            handleClose={closeModalAndClearForm}
            sizeVariant={"small"}
            {...styles.editModal}
        >
            <StyledWrapper id="popup-visual-navigation-edit">
                <GridContainer>
                    <GridItem {...styles.modalInputGrid}>
                        <StyledWrapper>
                            <TextField
                                type="text"
                                label={"Filter Title"}
                                value={filterTitle}
                                onChange={e => titleChangeHandler(e.target.value)}
                                onBlur={e => validateTitle(e.target.value)}
                                required
                                error={!!titleError}
                                {...(titleError ? styles.textFieldsErrorStyle : styles.formTextField)}
                            />
                            {titleError && <Typography {...styles.errorText}>{titleRequiredFieldMessage}</Typography>}
                        </StyledWrapper>
                        <StyledWrapper>
                            <TextField
                                type="number"
                                label={"Slide No."}
                                value={""+sequenceNumber}
                                onChange={e => sequenceChangeHandler(Number(e.target.value))}
                                onBlur={e => validateSequence(Number(e.target.value))}
                                required
                                error={!!sequenceError}
                                {...(sequenceError ? styles.textFieldsErrorStyle : styles.sequenceTextField)}
                            />
                            {sequenceError && <Typography {...styles.errorText}>{sequenceRequiredFieldMessage}</Typography>}
                        </StyledWrapper>
                    </GridItem>
                    <GridItem width={12} {...styles.radioGridItem}>
                        <RadioGroup
                            horizontal={true}
                            value={selectedRadio}
                            onChange={(e: any) => handleRadioChange(e.target.value)}
                            {...styles.radioListGroup}
                        >
                            <Radio value="imgNum">{"ADI Image Number"}</Radio>
                            <Radio value="pimId">{"PIM Brand ID"}</Radio>
                            <Radio value="imgName">{"Image Name"}</Radio>
                        </RadioGroup>
                        <TextField
                            type="text"
                            placeholder={`Enter ${selectedRadio === "imgNum"
                                ? "ADI Image Number"
                                : selectedRadio === "pimId"
                                    ? "PIM Brand ID"
                                    : "Image Name"
                                }`}
                            value={imageNumber}
                            onChange={e => imageChangeHandler(e.target.value)}
                            onBlur={e => validateImage(e.target.value, selectedRadio)}
                            required
                            error={!!imageNumberError}
                            {...(imageNumberError ? styles.textFieldsErrorStyle : styles.formTextField)}
                        />
                        {imageNumberError && <Typography {...styles.errorText}>{imageNumberError}</Typography>}
                    </GridItem>
                    <GridItem {...styles.modalInputGrid}>
                        <StyledWrapper>
                            <TextField
                                type="text"
                                label={"GA Promo Tag"}
                                value={gaPromoTag}
                                onChange={e => gaPromoTagChangeHandler(e.target.value)}
                                onBlur={e => validateGaPromoTag(e.target.value)}
                                required
                                error={!!gaPromoTagError}
                                {...(gaPromoTagError ? styles.textFieldsErrorStyle : styles.formTextField)}
                            />
                            {gaPromoTagError && <Typography {...styles.errorText}>{gaPromoTagRequiredFieldMessage}</Typography>}
                        </StyledWrapper>
                    </GridItem>
                    <GridItem {...styles.modalInputGrid}>
                        <StyledWrapper>
                            <TextField
                                type="text"
                                label={"Link"}
                                value={outsideLink}
                                onChange={e => ousideLinkChangeHandler(e.target.value)}
                                required ={false}
                                {...(styles.formTextField)}
                           
                               />
                        </StyledWrapper>
                    </GridItem>
                    <GridItem {...styles.modalInputGrid}>
                        <Button
                            onClick={() =>
                                SaveVisualNavigationPopupData(
                                    filterTitle,
                                    dataForGridItemIndex,
                                    imageNumber,
                                    gaPromoTag,
                                    selectedRadio,
                                    sequenceNumber,
                                    outsideLink
                                )
                            }
                            variant="primary"
                            className="modalSave"
                            disabled={isSubmitting || !isSubmitEnabled}
                        >
                            {translate("Save")}
                        </Button>
                        <Button onClick={closeModalAndClearForm} variant="secondary" className="modalCancel">
                            {translate("Cancel")}
                        </Button>
                    </GridItem>
                </GridContainer>
            </StyledWrapper>
        </Modal>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(ADIProductListVisualFilterModal);